import { ParamMap } from '@angular/router';
import { DiscoverRouteTypeEnum } from '../enums/discover-route-type.enum';

export class DiscoverRouteModel {
    type: DiscoverRouteTypeEnum;
    value?: string;
    queryParamMap?: ParamMap;

    constructor(type: DiscoverRouteTypeEnum, value?: string, queryParamMap?: ParamMap) {
        this.type = type;
        this.value = value;
        this.queryParamMap = queryParamMap;
    }
}
